import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { getIsAbnLoyaltyProgramEnabled } from '~/src/features/domru-bonus/constants/abnVariants';
import InfoHint from '~/src/features/payments-abn/components/InfoHint';
import WriteOffDetail from '~/src/features/payments-abn/components/WriteOffDetail';
import { selectBonusHint } from '~/src/features/payments-abn/store/selectors/selectBonusHint';
import { selectBonusText } from '~/src/features/payments-abn/store/selectors/selectBonusText';
import { TState } from '~/src/store';

/**
 * Детализация информации о списании бонусов
 */
const BonusesDetail = (): JSX.Element | null => {
    const isTablet = useMatchMedia(`(max-width: ${wideBreakpoints.tablet})`);

    const {
        payment: { paymentData: { paymentSum, bonusesValue, isUseBonuses } },
    } = useSelector((state: TState) => state);

    const hintData = useSelector(selectBonusHint(isTablet));
    const writeOffs = useSelector(selectBonusText);

    const isWriteOffDetailShown = useMemo(
        () => getIsAbnLoyaltyProgramEnabled()
            ? !!bonusesValue && bonusesValue <= (paymentSum / 0.2)
            : !!bonusesValue && bonusesValue <= paymentSum,
        [bonusesValue, paymentSum],
    );

    if (!isUseBonuses) {
        return null;
    }

    return (
        <>
            {isWriteOffDetailShown && (
                <WriteOffDetail writeOffs={writeOffs}/>
            )}
            {hintData && <InfoHint {...hintData}/>}
        </>
    );
};

export default BonusesDetail;
